import React, { useCallback, useEffect, useState } from "react";
import images from "../constants/images";

const FALLBACK_SRC = images.bottel_img;

function normalizeSrc(src) {
  if (src == null) return "";
  const s = String(src).trim();
  return s;
}

const ProductImage = ({ src, alt = "", className, style, ...rest }) => {
  const dynamic = normalizeSrc(src);
  const [displaySrc, setDisplaySrc] = useState(() =>
    dynamic ? dynamic : FALLBACK_SRC
  );

  useEffect(() => {
    const next = normalizeSrc(src);
    setDisplaySrc(next ? next : FALLBACK_SRC);
  }, [src]);

  const handleError = useCallback(() => {
    setDisplaySrc((current) =>
      current === FALLBACK_SRC ? current : FALLBACK_SRC
    );
  }, []);

  return (
    <img
      src={displaySrc}
      onError={handleError}
      alt={alt}
      className={className}
      style={style}
      {...rest}
    />
  );
};

export default ProductImage;
